export type WidgetIdentity = { administrator?: boolean; permissions?: string[] } | undefined | null;

export const hasWidgetPermission = (identity: WidgetIdentity, permission: string): boolean =>
    !!identity && (!!identity.administrator || (identity.permissions ?? []).includes(permission));
